// import { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import "rsuite/dist/rsuite-no-reset.min.css";
// import "./Date.css";
// import { addFilters } from "../../store/slices/FilterSliceManpowerDealerReview";
// import ViMultiSelect from "../Multi-Select-Dropdown/ViMultiSelectDropdownManpowerDealerReview";
// import { useQuery } from "@tanstack/react-query";
// import * as api from "./apiManPowerDealerReviewFilter";

// export default function ManPowerDealerReviewFilter() {
//   const dispatch = useDispatch();
//   const { data: dealerReviewData, submittedDealerReviewFilter } = useSelector(
//     (state) => state.filtersDealerReview
//   );
//   const { data: reduxData, submitted } = useSelector(
//     (state) => state.filtersManpowerDealerReview
//   );

//   // Single state object for all filters
//   const [filters, setFilters] = useState({
//     region: [],
//     new_region: [],
//     rm: [],
//     area_manager: [],
//     area_office: [],
//     tsm_name: [],
//     state: [],
//     new_state: [],
//     state_office: [],
//     Partner_Type: [],
//     dealer_name: [],
//     dealer_code: [],
//     Product_Line: [],
//     lob: [],
//   });

//   // Update filters from dealerReviewData
//   useEffect(() => {
//     if (dealerReviewData) {
//       setFilters((prev) => ({
//         ...prev,
//         region: dealerReviewData.region || [],
//         state: dealerReviewData.state || [],
//         state_office: dealerReviewData.state_office || [],
//         dealer_name: dealerReviewData.dealer_name || [],
//         dealer_code: dealerReviewData.dealer_code || [],
//         Product_Line: dealerReviewData.Product_Line || [],
//         lob: dealerReviewData.lob || [],
//         Partner_Type: dealerReviewData.Partner_Type || [],
//       }));
//     }
//   }, [dealerReviewData]);

//   // Update handler
//   const handleFilterChange = (key, value) => {
//     setFilters((prev) => ({ ...prev, [key]: value }));
//   };

//   // Use filters directly
//   const f = filters;

//   const [clicked, setClicked] = useState(1);

//   // --- API QUERIES ---
//   const queryConfig = (key, fn) => ({
//     queryKey: [key, submitted, f],
//     queryFn: () => fn(f),
//     staleTime: 0,
//   });

//   const { data: regions, isLoading: rL } = useQuery(
//     queryConfig("region", api.fetchRegion)
//   );
//   const { data: newRegion, isLoading: nrL } = useQuery(
//     queryConfig("newRegion", api.fetchNewRegion)
//   );
//   const { data: rm, isLoading: rmL } = useQuery(queryConfig("rm", api.fetchRM));
//   const { data: AreaManager, isLoading: amL } = useQuery(
//     queryConfig("area manager", api.fetchAreaManager)
//   );
//   const { data: AreaOffice, isLoading: aol } = useQuery(
//     queryConfig("area office", api.fetchAreaOffice)
//   );
//   const { data: TsmName, isLoading: tsl } = useQuery(
//     queryConfig("tsm name", api.fetchTsmName)
//   );
//   const { data: states, isLoading: sL } = useQuery(
//     queryConfig("states", api.fetchStates)
//   );
//   const { data: Newstates, isLoading: nsL } = useQuery(
//     queryConfig("NewStates", api.fetchNewState)
//   );
//   const { data: statesoffice, isLoading: soL } = useQuery(
//     queryConfig("statesoffice", api.fetchStatesOffice)
//   );
//   const { data: PartnerType, isLoading: poL } = useQuery(
//     queryConfig("PartnerType", api.fetchPartnerType)
//   );
//   const { data: dealer, isLoading: dL } = useQuery(
//     queryConfig("dealer", api.fetchDealer)
//   );
//   const { data: dealercode, isLoading: dcL } = useQuery(
//     queryConfig("dealercode", api.fetchDealercode)
//   );
//   const { data: productLine, isLoading: plL } = useQuery(
//     queryConfig("productLine", api.fetchProductLine)
//   );
//   const { data: lob, isLoading: lobL } = useQuery(
//     queryConfig("lob", api.fetchLOB)
//   );

//   async function handleSearch() {
//     const userSelectedFilter = {
//       data: f,
//       submitted: clicked + 1,
//     };

//     dispatch(addFilters(userSelectedFilter));
//     setClicked((prev) => prev + 1);
//   }

//   // Debug: Log filter state changes
//   useEffect(() => {
//     console.log("Current filter state:", filters);
//   }, [filters]);

//   const handleRefresh = () => window.location.reload();

//   return (
//     <section>
//       <div className="border-[#2c8a8b] border rounded-md grid grid-cols-2 gap-2 p-2 md:grid-cols-4 lg:grid-cols-7">
//         <FilterItem
//           label="Region"
//           options={regions}
//           onSelect={(value) => handleFilterChange("region", value)}
//           selected={filters.region}
//           keey="region"
//           loading={rL}
//         />
//         <FilterItem
//           label="New Region"
//           options={newRegion}
//           onSelect={(value) => handleFilterChange("new_region", value)}
//           selected={filters.new_region}
//           keey="new_region"
//           loading={nrL}
//         />
//         <FilterItem
//           label="RM"
//           options={rm}
//           onSelect={(value) => handleFilterChange("rm", value)}
//           selected={filters.rm}
//           keey="rm"
//           loading={rmL}
//         />
//         <FilterItem
//           label="Area Manager"
//           options={AreaManager}
//           onSelect={(value) => handleFilterChange("area_manager", value)}
//           selected={filters.area_manager}
//           keey="area_manager"
//           loading={amL}
//         />
//         <FilterItem
//           label="Area Office"
//           options={AreaOffice}
//           onSelect={(value) => handleFilterChange("area_office", value)}
//           selected={filters.area_office}
//           keey="area_office"
//           loading={aol}
//         />
//         <FilterItem
//           label="TSM Name"
//           options={TsmName}
//           onSelect={(value) => handleFilterChange("tsm_name", value)}
//           selected={filters.tsm_name}
//           keey="tsm_name"
//           loading={tsl}
//         />
//         <FilterItem
//           label="State"
//           options={states}
//           onSelect={(value) => handleFilterChange("state", value)}
//           selected={filters.state}
//           keey="state"
//           loading={sL}
//         />
//         <FilterItem
//           label="New State"
//           options={Newstates}
//           onSelect={(value) => handleFilterChange("new_state", value)}
//           selected={filters.new_state}
//           keey="new_state"
//           loading={nsL}
//         />
//         <FilterItem
//           label="State Office"
//           options={statesoffice}
//           onSelect={(value) => handleFilterChange("state_office", value)}
//           selected={filters.state_office}
//           keey="state_office"
//           loading={soL}
//         />
//         <FilterItem
//           label="Partner Type"
//           options={PartnerType}
//           onSelect={(value) => handleFilterChange("Partner_Type", value)}
//           selected={filters.Partner_Type}
//           keey="Partner_Type"
//           loading={poL}
//         />
//         <FilterItem
//           label="Dealer Name"
//           options={dealer}
//           onSelect={(value) => handleFilterChange("dealer_name", value)}
//           selected={filters.dealer_name}
//           keey="dealer_name"
//           loading={dL}
//         />
//         <FilterItem
//           label="Dealer Code"
//           options={dealercode}
//           onSelect={(value) => handleFilterChange("dealer_code", value)}
//           selected={filters.dealer_code}
//           keey="dealer_code"
//           loading={dcL}
//         />
//         <FilterItem
//           label="Product Line"
//           options={productLine}
//           onSelect={(value) => handleFilterChange("Product_Line", value)}
//           selected={filters.Product_Line}
//           keey="Product_Line"
//           loading={plL}
//         />
//         <FilterItem
//           label="LOB"
//           options={lob}
//           onSelect={(value) => handleFilterChange("lob", value)}
//           selected={filters.lob}
//           keey="lob"
//           loading={lobL}
//         />

//         <div className="flex items-end gap-1 col-span-2">
//           <button
//             className="text-white w-full rounded-md px-2 py-1 bg-[#2A5775]"
//             type="button"
//             onClick={handleSearch}
//           >
//             Apply All
//           </button>
//           <button
//             className="text-white w-full rounded-md px-2 py-1 bg-[#2A5775]"
//             onClick={handleRefresh}
//           >
//             Reset
//           </button>
//         </div>
//       </div>
//     </section>
//   );
// }

// const FilterItem = ({ label, options, onSelect, selected, keey, loading }) => (
//   <div className="flex flex-col justify-center">
//     <label className="font-semibold py-1 text-xs text-[#2A5775] whitespace-nowrap">
//       {label}
//     </label>
//     <ViMultiSelect
//       options={options || []}
//       onSelectionChange={onSelect}
//       opnsSelected={selected}
//       keey={keey}
//       isLoading={loading}
//     />
//   </div>
// );

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "rsuite/dist/rsuite-no-reset.min.css";
import "./Date.css";
import { addFilters } from "../../store/slices/FilterSliceManpowerDealerReview";
import ViMultiSelect from "../Multi-Select-Dropdown/ViMultiSelectDropdownManpowerDealerReview";
import { useQuery } from "@tanstack/react-query";
import * as api from "./apiManPowerDealerReviewFilter";

/* ---------- INITIAL STATE ---------- */
const INITIAL_FILTERS = {
  region: [],
  new_region: [],
  rm: [],
  area_manager: [],
  area_office: [],
  tsm_name: [],
  state: [],
  new_state: [],
  state_office: [],
  Partner_Type: [],
  dealer_name: [],
  dealer_code: [],
  Product_Line: [],
  lob: [],
};

export default function ManPowerDealerReviewFilter() {
  const dispatch = useDispatch();

  const { data: dealerReviewData } = useSelector(
    (state) => state.filtersDealerReview,
  );
  const { submitted } = useSelector(
    (state) => state.filtersManpowerDealerReview,
  );

  /* ---------- FILTER STATE ---------- */
  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [initialFilters, setInitialFilters] = useState(INITIAL_FILTERS);
  const [clicked, setClicked] = useState(1);

  /* ---------- CAPTURE ORIGINAL STATE WHEN MODAL OPENS ---------- */
  useEffect(() => {
    if (dealerReviewData) {
      const mappedFilters = {
        ...INITIAL_FILTERS,
        region: dealerReviewData.region || [],
        state: dealerReviewData.state || [],
        state_office: dealerReviewData.state_office || [],
        dealer_name: dealerReviewData.dealer_name || [],
        dealer_code: dealerReviewData.dealer_code || [],
        Product_Line: dealerReviewData.Product_Line || [],
        lob: dealerReviewData.lob || [],
        Partner_Type: dealerReviewData.Partner_Type || [],
      };

      setFilters(mappedFilters);
      setInitialFilters(mappedFilters); // 👈 snapshot for Reset
    }
  }, [dealerReviewData]);

  /* ---------- HANDLERS ---------- */
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  const handleSearch = () => {
    dispatch(
      addFilters({
        data: filters,
        submitted: clicked + 1,
      }),
    );
    setClicked((prev) => prev + 1);
  };

  const handleReset = () => {
    setFilters(initialFilters);

    dispatch(
      addFilters({
        data: initialFilters,
        submitted: clicked + 1,
      }),
    );
    setClicked((prev) => prev + 1);
  };

  /* ---------- QUERY CONFIG ---------- */
  const queryConfig = (key, fn) => ({
    queryKey: [key, submitted, filters],
    queryFn: () => fn(filters),
    staleTime: 0,
  });

  /* ---------- API CALLS ---------- */
  const { data: regions, isLoading: rL } = useQuery(
    queryConfig("region", api.fetchRegion),
  );
  const { data: newRegion, isLoading: nrL } = useQuery(
    queryConfig("newRegion", api.fetchNewRegion),
  );
  const { data: rm, isLoading: rmL } = useQuery(queryConfig("rm", api.fetchRM));
  const { data: AreaManager, isLoading: amL } = useQuery(
    queryConfig("areaManager", api.fetchAreaManager),
  );
  const { data: AreaOffice, isLoading: aol } = useQuery(
    queryConfig("areaOffice", api.fetchAreaOffice),
  );
  const { data: TsmName, isLoading: tsl } = useQuery(
    queryConfig("tsmName", api.fetchTsmName),
  );
  const { data: states, isLoading: sL } = useQuery(
    queryConfig("states", api.fetchStates),
  );
  const { data: Newstates, isLoading: nsL } = useQuery(
    queryConfig("newStates", api.fetchNewState),
  );
  const { data: statesoffice, isLoading: soL } = useQuery(
    queryConfig("statesOffice", api.fetchStatesOffice),
  );
  const { data: PartnerType, isLoading: poL } = useQuery(
    queryConfig("partnerType", api.fetchPartnerType),
  );
  const { data: dealer, isLoading: dL } = useQuery(
    queryConfig("dealer", api.fetchDealer),
  );
  const { data: dealercode, isLoading: dcL } = useQuery(
    queryConfig("dealerCode", api.fetchDealercode),
  );
  const { data: productLine, isLoading: plL } = useQuery(
    queryConfig("productLine", api.fetchProductLine),
  );
  const { data: lob, isLoading: lobL } = useQuery(
    queryConfig("lob", api.fetchLOB),
  );

  /* ---------- UI ---------- */
  return (
    <section>
      <div className="border-[#2c8a8b] border rounded-md grid grid-cols-2 gap-2 p-2 md:grid-cols-4 lg:grid-cols-7">
        <FilterItem
          label="Region"
          options={regions}
          selected={filters.region}
          onSelect={(v) => handleFilterChange("region", v)}
          loading={rL}
        />
        <FilterItem
          label="New Region"
          options={newRegion}
          selected={filters.new_region}
          onSelect={(v) => handleFilterChange("new_region", v)}
          loading={nrL}
        />
        <FilterItem
          label="RM"
          options={rm}
          selected={filters.rm}
          onSelect={(v) => handleFilterChange("rm", v)}
          loading={rmL}
        />
        <FilterItem
          label="Area Manager"
          options={AreaManager}
          selected={filters.area_manager}
          onSelect={(v) => handleFilterChange("area_manager", v)}
          loading={amL}
        />
        <FilterItem
          label="Area Office"
          options={AreaOffice}
          selected={filters.area_office}
          onSelect={(v) => handleFilterChange("area_office", v)}
          loading={aol}
        />
        <FilterItem
          label="TSM Name"
          options={TsmName}
          selected={filters.tsm_name}
          onSelect={(v) => handleFilterChange("tsm_name", v)}
          loading={tsl}
        />
        <FilterItem
          label="State"
          options={states}
          selected={filters.state}
          onSelect={(v) => handleFilterChange("state", v)}
          loading={sL}
        />
        <FilterItem
          label="New State"
          options={Newstates}
          selected={filters.new_state}
          onSelect={(v) => handleFilterChange("new_state", v)}
          loading={nsL}
        />
        <FilterItem
          label="State Office"
          options={statesoffice}
          selected={filters.state_office}
          onSelect={(v) => handleFilterChange("state_office", v)}
          loading={soL}
        />
        <FilterItem
          label="Partner Type"
          options={PartnerType}
          selected={filters.Partner_Type}
          onSelect={(v) => handleFilterChange("Partner_Type", v)}
          loading={poL}
        />
        <FilterItem
          label="Dealer Name"
          options={dealer}
          selected={filters.dealer_name}
          onSelect={(v) => handleFilterChange("dealer_name", v)}
          loading={dL}
        />
        <FilterItem
          label="Dealer Code"
          options={dealercode}
          selected={filters.dealer_code}
          onSelect={(v) => handleFilterChange("dealer_code", v)}
          loading={dcL}
        />
        <FilterItem
          label="Product Line"
          options={productLine}
          selected={filters.Product_Line}
          onSelect={(v) => handleFilterChange("Product_Line", v)}
          loading={plL}
        />
        <FilterItem
          label="LOB"
          options={lob}
          selected={filters.lob}
          onSelect={(v) => handleFilterChange("lob", v)}
          loading={lobL}
        />

        <div className="flex items-end gap-1 col-span-2">
          <button
            className="text-white w-full rounded-md px-2 py-1 bg-[#2A5775]"
            onClick={handleSearch}
          >
            Apply All
          </button>
          <button
            className="text-white w-full rounded-md px-2 py-1 bg-[#2A5775]"
            onClick={handleReset}
          >
            Reset
          </button>
        </div>
      </div>
    </section>
  );
}

/* ---------- FILTER ITEM ---------- */
const FilterItem = ({ label, options, onSelect, selected, loading }) => (
  <div className="flex flex-col justify-center">
    <label className="font-semibold py-1 text-xs text-[#2A5775] whitespace-nowrap">
      {label}
    </label>
    <ViMultiSelect
      options={options || []}
      onSelectionChange={onSelect}
      opnsSelected={selected}
      isLoading={loading}
    />
  </div>
);
